import React from "react";
import { StackProps } from "./Stack-types";
import { StackContainer } from "./Stack-styles";
import Columns from "./Columns-component";

// iOS raise an error when we are using `direction`
// as props.
// so now for a workaround I used `dir`.
// https://stackoverflow.com/questions/60479653/invalid-ygdirection-row-should-be-one-of-inherit-ltr-rtl-react-native
function Stack({ direction, ...props }: StackProps) {
  return (
    <StackContainer dir={direction} {...props}>
      {props.columns ? (
        <Columns columns={props.columns} fillIfEmpty={props.fillIfEmpty}>
          {props.children}
        </Columns>
      ) : (
        props.children
      )}
    </StackContainer>
  );
}

export default Stack;
